'use client'

import { Tooltip } from '@skop-app/lib-front'

import PublicAuthSessionGate from '@/components/listeners/PublicAuthSessionGate'
import { DrawerRegistryProvider } from '@/components/drawers/drawer.provider'
import { ModalRegistryProvider } from '@/components/modals/modal.provider'
import {
  PUBLIC_SESSION_RUNTIME,
  SessionRuntimeProvider,
} from '@/context/SessionRuntimeContext'
import { DataProvider } from '@/context/DataContext'

export function PublicAppProviders({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <SessionRuntimeProvider value={PUBLIC_SESSION_RUNTIME}>
      <DataProvider
        key={PUBLIC_SESSION_RUNTIME.sessionScopeKey}
        persistCache={false}
      >
        <ModalRegistryProvider>
          <DrawerRegistryProvider>
            <Tooltip.Provider delayDuration={50}>
              <PublicAuthSessionGate />
              {children}
            </Tooltip.Provider>
          </DrawerRegistryProvider>
        </ModalRegistryProvider>
      </DataProvider>
    </SessionRuntimeProvider>
  )
}
